import axios from 'axios';

import type { GetConversationHistoryResult, Request } from './request';

export type GetConversationHistoryClientApiCall = (
	data: Request['query'],
	options?: { signal?: AbortSignal },
) => Promise<GetConversationHistoryResult>;

const AI_COMPANION_GET_HISTORY_CLIENT_ENDPOINT = '/api/ai-companion/get-conversation-history';

export const getConversationHistoryApi: GetConversationHistoryClientApiCall = async (query, options) => {
	const res = await axios.get(AI_COMPANION_GET_HISTORY_CLIENT_ENDPOINT, { params: query, signal: options?.signal });
	return res.data as ReturnType<GetConversationHistoryClientApiCall>;
};
